import "./NewsAppPushMessages.scss";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import moment from "moment/moment";
import DateInput from "@/components/Common/DateInput/DateInput.vue";
import NewsAppPushMessagesListTable from "@/components/News/NewsAppPushMessagesListTable/NewsAppPushMessagesListTable.vue";
import NewsAppPushMessageEditDialog from "@/components/News/NewsAppPushMessageEditDialog/NewsAppPushMessageEditDialog.vue";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "NewsAppPushMessages",
  components: {
    DateInput,
    NewsAppPushMessagesListTable,
    NewsAppPushMessageEditDialog
  },

  data: () => ({
    createAppPushMessageDialog: false,
    newsSelectionDialog: false,
    loadingAvailableNews: false,
    availableNewsForAppPushMessage: null,
    newsForPushMessage: null
  }),
  async mounted() {
    await this.$store.dispatch("getCurrentUser");
    if (!this.isAdmin && !this.userCanSendPushMessages) {
      await this.$router.push(`/news/`);
      await this.createError({ text: "Zugriff verweigert" });
    }
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    userCanSendPushMessages() {
      return this.$store.state.currentUser?.scopes.includes(
        "role:news_app_push_messages"
      );
    },
    newsSelectionDisabled() {
      if (!this.availableNewsForAppPushMessage?.length) {
        return true;
      }
      if (!this.newsForPushMessage) {
        return true;
      }
      return false;
    }
  },
  methods: {
    formatDate(date) {
      if (!date?.length) {
        return;
      }
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    cancelNewsSelection() {
      this.newsSelectionDialog = false;
      this.availableNewsForAppPushMessage = null;
      this.newsForPushMessage = null;
    },
    async selectNewsForAppPushMessage() {
      if (!this.newsForPushMessage) {
        await this.createError({ text: "Bitte wählen Sie eine Nachricht." });
        return;
      }
      this.availableNewsForAppPushMessage = null;
      this.newsSelectionDialog = false;
      this.createAppPushMessageDialog = true;
    },
    getAvailableNewsSelectionText(news) {
      const releaseDate = news.web_release_date
        ? this.formatDate(news.web_release_date)
        : "k.A.";
      const expireDate = news.web_expire_date
        ? this.formatDate(news.web_expire_date)
        : "k.A.";

      return `${news.title} (${releaseDate} - ${expireDate})`;
    },
    async getAvailableNewsForAppPushMessage() {
      this.loadingAvailableNews = true;
      this.newsSelectionDialog = true;

      this.availableNewsForAppPushMessage = null;
      this.newsForPushMessage = null;

      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal
      };
      try {
        const response = await axios.get(
          env.news_api_client_url + "app_push_message/available-news",
          {
            params,
            headers
          }
        );
        this.availableNewsForAppPushMessage = response.data;
      } catch (error) {
        await this.createError(error);
        this.availableNewsForAppPushMessage = null;
      } finally {
        this.loadingAvailableNews = false;
      }
    },
    async afterCreateAppPushMessage(data) {
      this.createAppPushMessageDialog = false;
      if (!(data instanceof Event)) {
        await this.$refs.pushMessagesListTable.fetchData();
      }
    },
    async createError(error) {
      await this.$store.dispatch("createError", error);
    },
    async createSuccess(successMessage) {
      await this.$store.dispatch("createSuccess", successMessage);
    }
  }
};
